export const normalizePhone = (value, previousValue) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 3) {
      return onlyNums + '-'
    }
    if (onlyNums.length === 6) {
      return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3) + '-'
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 6) {
    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3)
  }
  return (
    onlyNums.slice(0, 3) +
    '-' +
    onlyNums.slice(3, 6) +
    '-' +
    onlyNums.slice(6, 10)
  )
}

export const normalizeAccountNumber = (value, previousValue) => {
  if (!value) return value
  const onlyNums = value.replace(/[^\d]/g, '')
  return onlyNums.slice(0, 15)
}

export const normalizeRtnNumber = (value, previousValue) => {
  if (!value) return value
  const onlyNums = value.replace(/[^\d]/g, '')
  return onlyNums.slice(0, 9)
}

export const normalizeTinNumber = (value, previousValue) => {
  if (!value) return value
  const onlyNums = value.replace(/[^\d]/g, '')
  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 2) {
      return onlyNums + '-'
    }
  }
  if (onlyNums.length <= 2) {
    return onlyNums
  }
  return onlyNums.slice(0, 2) + '-' + onlyNums.slice(2, 9)
}

export const normalizeZipCode = (value, previousValue) => {
  if (!value) return value
  const onlyNums = value.replace(/[^\d]/g, '')
  return onlyNums ? onlyNums.slice(0, 5) : null
}



// WEBPACK FOOTER //
// ./src/services/normalizations.js